var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OrderForm',{attrs:{"order":_vm.order,"formType":_vm.formType,"buttonLoading":_vm.buttonLoading},on:{"saveOrder":_vm.updateOrder}})}
var staticRenderFns = []

export { render, staticRenderFns }